import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { STATE_SIGNING_REQUIREMENTS_ACTION_TYPE } from '../actions';

const initialState = {};

const stateSigningRequirementsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case STATE_SIGNING_REQUIREMENTS_ACTION_TYPE.GET_STATES:
        return payload;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default stateSigningRequirementsReducer;
